import { serviceSettingsConstants } from "../_constants";

export function serviceSettingsList(state = {}, action) {
  switch (action.type) {
    case serviceSettingsConstants.GET_SERVICE_SETTINGS_LIST_REQUEST:
      return {
        loading: true,
      };
    case serviceSettingsConstants.GET_SERVICE_SETTINGS_LIST_SUCCESS:
      return {
        items: action.serviceSettings,
      };
    case serviceSettingsConstants.GET_SERVICE_SETTINGS_LIST_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function serviceSettingsById(state = {}, action) {
  switch (action.type) {
    case serviceSettingsConstants.GET_SERVICE_SETTINGS_REQUEST:
      return {
        loading: true,
      };
    case serviceSettingsConstants.GET_SERVICE_SETTINGS_SUCCESS:
      return {
        item: action.service,
      };
    case serviceSettingsConstants.GET_SERVICE_SETTINGS_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}



export function updateServiceSettingsByTypes(state = {}, action) {
  switch (action.type) {
    case serviceSettingsConstants.UPDATE_SERVICE_TYPES_REQUEST:
      return {
        updateNotes: true,
      };
    case serviceSettingsConstants.UPDATE_SERVICE_TYPES_SUCCESS:
      return action.data;
    case serviceSettingsConstants.UPDATE_SERVICE_TYPES_FAILURE:
      return action.error;
    default:
      return state;
  }
}

export function updateServiceSettingsByStatus(state = {}, action) {
  switch (action.type) {
    case serviceSettingsConstants.UPDATE_SERVICE_STATUS_REQUEST:
      return {
        updateNotes: true,
      };
    case serviceSettingsConstants.UPDATE_SERVICE_STATUS_SUCCESS:
      return action.data;
    case serviceSettingsConstants.UPDATE_SERVICE_STATUS_FAILURE:
      return action.error;
    default:
      return state;
  }
}
